module.exports = __webpack_public_path__ + "static/media/invoice-title.182c192b.svg";